<app-bannerregistrados></app-bannerregistrados>

<div class="contenedorMain">
    <div class="contenedorChild">

        <div class="contenedorChildTwo">

            <div class="col1">
                <h2 class="titleInterno ">
                    <svg class="iconoVolver" (click)="volver()" role="button" aria-label="Volver a Registrados"
                        width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M26.6668 18.8335H17.2268L19.3102 16.6502C19.9452 15.9852 19.9202 14.9302 19.2552 14.2935C18.5885 13.6602 17.5352 13.6835 16.8985 14.3502L12.1268 19.3502C12.0635 19.4168 12.0352 19.5002 11.9835 19.5752C11.9152 19.6735 11.8385 19.7635 11.7935 19.8768C11.7318 20.0285 11.7118 20.1868 11.6985 20.3485C11.6935 20.4002 11.6668 20.4468 11.6668 20.5002C11.6668 20.5035 11.6685 20.5052 11.6685 20.5085C11.6702 20.7252 11.7118 20.9402 11.7968 21.1435C11.8802 21.3452 12.0035 21.5268 12.1552 21.6802L17.1552 26.6785C17.4802 27.0035 17.9068 27.1668 18.3335 27.1668C18.7602 27.1668 19.1868 27.0035 19.5118 26.6785C20.1635 26.0268 20.1635 24.9735 19.5118 24.3218L17.3568 22.1668H26.6668C27.5868 22.1668 28.3335 21.4202 28.3335 20.5002C28.3335 19.5802 27.5868 18.8335 26.6668 18.8335ZM20.0002 33.8335C12.6485 33.8335 6.66683 27.8518 6.66683 20.5002C6.66683 13.1485 12.6485 7.16683 20.0002 7.16683C27.3518 7.16683 33.3335 13.1485 33.3335 20.5002C33.3335 27.8518 27.3518 33.8335 20.0002 33.8335ZM20.0002 3.8335C10.8102 3.8335 3.3335 11.3102 3.3335 20.5002C3.3335 29.6902 10.8102 37.1668 20.0002 37.1668C29.1902 37.1668 36.6668 29.6902 36.6668 20.5002C36.6668 11.3102 29.1902 3.8335 20.0002 3.8335Z"
                            fill="#DA291C" />
                        <mask id="mask0_426_4118" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="3" y="3"
                            width="34" height="35">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M26.6668 18.8335H17.2268L19.3102 16.6502C19.9452 15.9852 19.9202 14.9302 19.2552 14.2935C18.5885 13.6602 17.5352 13.6835 16.8985 14.3502L12.1268 19.3502C12.0635 19.4168 12.0352 19.5002 11.9835 19.5752C11.9152 19.6735 11.8385 19.7635 11.7935 19.8768C11.7318 20.0285 11.7118 20.1868 11.6985 20.3485C11.6935 20.4002 11.6668 20.4468 11.6668 20.5002C11.6668 20.5035 11.6685 20.5052 11.6685 20.5085C11.6702 20.7252 11.7118 20.9402 11.7968 21.1435C11.8802 21.3452 12.0035 21.5268 12.1552 21.6802L17.1552 26.6785C17.4802 27.0035 17.9068 27.1668 18.3335 27.1668C18.7602 27.1668 19.1868 27.0035 19.5118 26.6785C20.1635 26.0268 20.1635 24.9735 19.5118 24.3218L17.3568 22.1668H26.6668C27.5868 22.1668 28.3335 21.4202 28.3335 20.5002C28.3335 19.5802 27.5868 18.8335 26.6668 18.8335ZM20.0002 33.8335C12.6485 33.8335 6.66683 27.8518 6.66683 20.5002C6.66683 13.1485 12.6485 7.16683 20.0002 7.16683C27.3518 7.16683 33.3335 13.1485 33.3335 20.5002C33.3335 27.8518 27.3518 33.8335 20.0002 33.8335ZM20.0002 3.8335C10.8102 3.8335 3.3335 11.3102 3.3335 20.5002C3.3335 29.6902 10.8102 37.1668 20.0002 37.1668C29.1902 37.1668 36.6668 29.6902 36.6668 20.5002C36.6668 11.3102 29.1902 3.8335 20.0002 3.8335Z"
                                fill="white" />
                        </mask>
                        <g mask="url(#mask0_426_4118)">
                            <rect y="0.5" width="40" height="40" fill="#DA291C" />
                        </g>
                    </svg>


                    Estadísticas
                </h2>

            </div>
            <div class="col2">




            </div>
        </div>




        <div class="row">
            <div class="col-md-1">
                <p class="titleCodeUrl">URL:</p>
            </div>
            <div class="col-md-11"> <input type="text" class="form-control" disabled [value]=[url]></div>
        </div>
        <br>
        <p><b>Escaneos | Total: {{nro_visitas}}</b></p>

        <div class="row filaDatepicker">
            <label for="datepicker" class="labelDatepicker">Selecciona rango de fecha:</label>
            <div class="col-md-2">
                <input type="date" id="start" name="trip-start" class="datepicker" [(ngModel)]="rangoInicio" min="2025-01-01" />
            </div>
            <div class="col-md-2">
                <input type="date" id="start" name="trip-start" class="datepicker" [(ngModel)]="rangoFin" min="2025-01-01" />
            </div>

            <div class="col-md-2">
                <button type="button" class="btn-consultar" (click)="ConsultarFechas()"><i class="bi bi-search"></i> Consultar </button>
            </div>

        </div>

        <div class="row">

            <div class="col-md-2">
                <button type="button" class="descargar"  (click)="DescargarExcel()" *ngIf="mostrarBoton">  <i class="bi bi-file-earmark-ruled"></i>
                    Descargar Excel

                </button>
            </div>
           <!-- <div class="col-md-2">
                <button type="button" class="btn btn-danger" (click)="ConsultarFechas()">Descargar PDF</button>
            </div>-->
        </div>

        <div class="row">
            <p class="textoGraficos">Gráficos por País</p>
            <div class="col-md-6">
                <table class="table">
                    <thead>
                        <tr class="table-secondary">
                            <th>País</th>
                            <th>Vistas</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let result of QR_List_visitas">

                            <th>

                                <a>{{result.country}}</a>
                            </th>
                            <th>{{result.cantidad}}</th>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <div id="container2" style="width: 100%; height: 400px;"></div>
            </div>
        </div>

        <br>
        <div class="row">
            <div class="col-md-6">
                <p class="textoGraficos">Gráficos por Provincias</p>
                <select class="form-control" id="exampleSelect" (change)="cargaLista_Tabla_Combos($event)">
                    <option value="">Seleccionar Provincias</option>
                    <option *ngFor="let result of List_Reporte_Pais">
                        <p>{{result.city}}</p>
                    </option>
                </select>
            </div>
        </div>
        <br>
        <div class="row" *ngIf="limaDefecto">
        
          <div class="col-md-3">  <p style="text-align: left;"><b><i>Por defecto Lima</i></b></p></div>
        </div>
        <br>

        <div class="row">
            <div class="col-md-6">
                <table class="table">
                    <thead>
                        <tr class="table-secondary">
                            <th>Ciudad</th>
                            <th>Distrito</th>
                            <th>Vistas</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let result of List_Reporte_Pais_detalle_tabla">

                            <th>{{result.city}}</th>
                            <th>{{result.distrito}}</th>
                            <th>{{result.cantidad}}</th>

                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-md-6">
                <div id="container1" style="width: 100%; height: 400px;"></div>
            </div>
        </div>



        <br>
        <div class="row">
            <p class="textoGraficos">Gráficos por Dispositivos</p>
            <div class="col-md-6">

                <table class="table">
                    <thead>
                        <tr class="table-secondary">
                            <th scope="col">Dispositivos</th>
                            <th scope="col">Vistas</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let result of QR_List_Dispositivo">

                            <th>
                                {{result.tipo_dispositivo}}
                            </th>
                            <th>{{result.cantidad}}</th>
                        </tr>

                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <div id="container3" style="width: 100%; height: 400px;"></div>
            </div>
        </div>
    </div>

</div>

<app-footer></app-footer>